import React, { createContext, useContext, useState } from 'react';

const DummyDataContext = createContext(null);

export function DummyDataProvider({ children }) {
  const [isDummyDataEnabled, setIsDummyDataEnabled] = useState(false);

  return (
    <DummyDataContext.Provider
      value={{ isDummyDataEnabled, setIsDummyDataEnabled }}
    >
      {children}
    </DummyDataContext.Provider>
  );
}

export function useDummyData() {
  const context = useContext(DummyDataContext);
  if (!context) {
    throw new Error('useDummyData must be used within a DummyDataProvider');
  }
  return context;
}
